import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Hemorrhoids treatment type.
 */
export const HemorrhoidsTreatment = new TreatmentType({
  id: '15',
  name: ConsultationTreatmentTypes.Hemorrhoids,
  eligibleTreatmentTypes: [{ id: 3522, name: UpsellSlugs.RectalCreamAndSuppositoryUpsell }],
});
